export const GET_LIVE_CAMERA_DATA = "GET_LIVE_CAMERA_DATA";
export const LIVE_CAMERA_DATA_API_SUCCESS = "LIVE_CAMERA_DATA_API_SUCCESS";
export const LIVE_CAMERA_DATA_API_FAIL = "LIVE_CAMERA_DATA_API_FAIL";